class HeaderLanguageSelector extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
  }

  connectedCallback() {
    if (!this.details || !this.summary) return;
    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.handleKeydown);
    this.details.addEventListener('toggle', this.handleToggle);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleKeydown);
    if (this.details) this.details.removeEventListener('toggle', this.handleToggle);
  }

  handleDocumentClick(event) {
    if (this.details.open && !this.contains(event.target)) {
      this.close();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.details.open) {
      this.close(true);
    }
  }

  handleToggle() {
    this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
  }

  close(returnFocus = false) {
    this.details.removeAttribute('open');
    if (returnFocus) this.summary.focus();
  }
}

if (!customElements.get('header-language-selector')) {
  customElements.define('header-language-selector', HeaderLanguageSelector);
}
